import {reducerWithInitialState} from "typescript-fsa-reducers";
import { actions } from "../actions/Action";
import { deepCopyThingyState, deepCopyThingyStateAndMerge, LoginInitialState } from "../typing/loginstate";



export default reducerWithInitialState(LoginInitialState)
        .case(actions.createClient, (state,payload) => {
            const deepCopy=deepCopyThingyState(state);
            deepCopy.model.client = {...payload.NewMandant}
            // deepCopy.model.client.name = payload.NewMandant.name;
            // deepCopy.model.client.description = payload.NewMandant.description;
            
            return deepCopy;
        })
        .case(actions.SetUserDetail, (state,payload) => {
            const deepCopy = deepCopyThingyState(state);
            const deepCopy2 = deepCopyThingyStateAndMerge(deepCopy, payload);
            return deepCopy2;
        })
        ;
        ;
